export const actionTypes = {
    SET_BASEMAP: 'MAPS/SET_BASEMAP'
}